/* global axios */

import ApiClient from './ApiClient';

class ClosingNoteCategoriesAPI extends ApiClient {
  constructor() {
    super('closing_note_categories', { accountScoped: true });
  }

  get() {
    return axios.get(this.url);
  }

  create(payload) {
    return axios.post(this.url, { closing_note_category: payload });
  }

  update(id, payload) {
    return axios.patch(`${this.url}/${id}`, { closing_note_category: payload });
  }

  delete(id) {
    return axios.delete(`${this.url}/${id}`);
  }
}

export default new ClosingNoteCategoriesAPI();
